import { type BaseApplicationRepository } from "../../_Bases/BaseApplicationRepository";
import { type LocalDatabaseApplication } from "../../_Bases/BaseApplicationRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBApplicationRepository extends BaseIndexedDBRepository<
    LocalDatabaseApplication
> implements BaseApplicationRepository {
    public readonly source: InternalIndexedDBDatabase["applications"];
    protected readonly dataTypeName = "Application";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.applications;
    }

    public search(needle: string): Promise<Array<LocalDatabaseApplication>> {
        if(!needle) {
            return this.all();
        }

        return this.source
            .where("name")
            .startsWithIgnoreCase(needle)
            .toArray();
    }
}
